export const API_URL = process.env.REACT_APP_API_URL || 'https://79er4g0vx7.execute-api.us-east-1.amazonaws.com/Stage'
console.log(API_URL)
// 'https://z8831g1hr1.execute-api.us-east-2.amazonaws.com/Stage'
//export const API_URL = 'http://127.0.0.1:8000'
